import styled, { keyframes } from "styled-components";

/* Glowing pulse animation */
const glow = keyframes`
  0% { box-shadow: 0 0 10px rgba(0,255,255,0.2); }
  50% { box-shadow: 0 0 20px rgba(0,255,255,0.6); }
  100% { box-shadow: 0 0 10px rgba(0,255,255,0.2); }
`;

/* Section wrapper */
export const MLSectionWrapper = styled.section`
  padding: 20px 20px;
  background: linear-gradient(180deg, #111 0%, #1b1b1b 100%);
  color: white;
  position: relative;
  overflow: hidden;

  h3 {
    text-align: center;
    font-size: 1.5rem;
    color: #0ff;
    margin-bottom: 40px;
    letter-spacing: 1px;
  }

  /* Optional subtle Matrix background */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(
      0deg,
      rgba(0,255,0,0.03),
      rgba(0,255,0,0.03) 2px,
      transparent 2px,
      transparent 4px
    );
    pointer-events: none;
  }
`;

/* Scrollable horizontal container */
export const MLContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 25px;
  padding: 20px 10px;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: cyan;
    border-radius: 10px;
    box-shadow: 0 0 5px cyan;
  }
  &::-webkit-scrollbar-track {
    background: #111;
  }
`;

/* Individual Card */
export const MLCard = styled.div`
  min-width: 240px;
  max-width: 280px;
  padding: 10px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(255,255,255,0.03);
  backdrop-filter: blur(12px);
  border-left: 5px solid cyan;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: ${glow} 2s infinite;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 0 25px cyan, 0 0 50px cyan;
  }

  img {
    width: 35px;
    height: 35px;
    object-fit: contain;
    margin-bottom: 5px;
  }

  h5 {
    font-size: 1rem;
    margin-bottom: 8px;
    text-align: center;
  }

  p {
    font-size: 0.95rem;
    text-align: center;
    color: #ccc;
  }

  @media (max-width: 768px) {
    min-width: 200px;
    max-width: 220px;
    padding: 20px;
  }
`;
